import React from "react";

type Props = {
  propName: string;
  currentVal: number;
  handleChange: Function;
  labels: string[];
  index: number;
};

export default function XOptionsRadioButtons({
  propName,
  currentVal,
  handleChange,
  labels,
  index,
}: Props) {
  return (
    <div>
      {labels.map((label: string, labelIndex: number) => {
        return (
          <div>
            <input
              name={propName + index + labelIndex}
              value={labelIndex}
              id={propName + index + labelIndex}
              key={labelIndex}
              type="radio"
              checked={currentVal == labelIndex}
              onChange={() => handleChange(propName, labelIndex)}
            ></input>{" "}
            <label htmlFor={propName + index + labelIndex}>{label}</label>
          </div>
        );
      })}
    </div>
  );
}
